import { render, staticRenderFns } from "./english.vue?vue&type=template&id=2c45483d&scoped=true"
import script from "./english.vue?vue&type=script&lang=js"
export * from "./english.vue?vue&type=script&lang=js"
import style0 from "./english.vue?vue&type=style&index=0&id=2c45483d&prod&lang=css"
import style1 from "./english.vue?vue&type=style&index=1&id=2c45483d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c45483d",
  null
  
)

export default component.exports